var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"icon-style",attrs:{"contain":"","src":_vm.imgSRC,"aspect-ratio":"1/1","height":"18"}})}
var staticRenderFns = []

export { render, staticRenderFns }